import { Link } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { calcularPassos, useOnboardingProgress } from '../onboarding/useOnboardingProgress'

interface Passo {
  numero: number
  titulo: string
  href: string
  feito: boolean
  cta: string
}

export default function OnboardingBanner() {
  const user = useAuthStore((s) => s.user)
  const ehAdmin = user?.perfil === 'admin_tenant'
  const { data, isLoading } = useOnboardingProgress()

  if (!ehAdmin || isLoading || !data) return null

  const passos: Passo[] = calcularPassos(data).map((p, idx) => ({
    numero: idx + 1,
    titulo: p.titulo.replace(/^\d+\.\s*/, ''),
    href: p.ctaTo,
    feito: p.feito,
    cta: p.ctaLabel,
  }))

  const todoFeito = passos.every((p) => p.feito)
  if (todoFeito) return null

  const proximoPasso = passos.find((p) => !p.feito)

  return (
    <section
      data-testid="onboarding-banner"
      style={{
        background: 'linear-gradient(135deg, #1565C0 0%, #00897B 100%)',
        color: '#fff',
        padding: '1.5rem 1.75rem',
        borderRadius: 12,
        marginBottom: '1.5rem',
        boxShadow: '0 4px 12px rgba(21, 101, 192, 0.25)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 320px' }}>
          <h2 style={{ margin: 0, fontSize: '1.35rem', fontWeight: 600 }}>
            🚀 Vamos começar?
          </h2>
          <p style={{ margin: '0.5rem 0 0', opacity: 0.95, fontSize: '0.95rem' }}>
            Siga estes passos para configurar seu primeiro PMOC e gerar OS automaticamente.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'flex-end', alignSelf: 'center' }}>
          {proximoPasso && (
            <Link
              to={proximoPasso.href}
              data-testid="onboarding-cta-proximo"
              style={{
                background: '#fff',
                color: '#1565C0',
                padding: '0.65rem 1.25rem',
                borderRadius: 8,
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                whiteSpace: 'nowrap',
              }}
            >
              {proximoPasso.cta} →
            </Link>
          )}
          <Link
            to="/onboarding"
            data-testid="onboarding-cta-wizard"
            style={{
              color: '#fff',
              textDecoration: 'underline',
              fontSize: '0.85rem',
              opacity: 0.9,
            }}
          >
            Ver tour completo
          </Link>
        </div>
      </div>

      <ol
        style={{
          listStyle: 'none',
          padding: 0,
          margin: '1.25rem 0 0',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '0.75rem',
        }}
      >
        {passos.map((p) => (
          <li
            key={p.numero}
            data-testid={`onboarding-passo-${p.numero}`}
            style={{
              background: p.feito ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)',
              padding: '0.75rem',
              borderRadius: 8,
              border: p.feito ? '1px solid rgba(255,255,255,0.4)' : '1px solid transparent',
              opacity: p.feito ? 0.8 : 1,
            }}
          >
            <div style={{ fontSize: '0.75rem', opacity: 0.85, marginBottom: 4 }}>
              {p.feito ? '✓ Concluído' : `Passo ${p.numero}`}
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: 500 }}>{p.titulo}</div>
          </li>
        ))}
      </ol>
    </section>
  )
}
